import firebase from 'firebase'
const firebaseConfig = {
  apiKey: "AIzaSyAQKO8iiOGWQiEt_-MG8zTC2fv_D03MVB8",
  authDomain: "novosformsubs.firebaseapp.com",
  databaseURL: "https://novosformsubs.firebaseio.com",
  projectId: "novosformsubs",
  storageBucket: "novosformsubs.appspot.com",
  messagingSenderId: "790924651838",
  appId: "1:790924651838:web:2d7ffcd0f04731eed2506f"
};
export const db = firebase
  .initializeApp(firebaseConfig)
  .firestore()

// Export types that exists in Firestore
// export { TimeStamp, GeoPoint } = firebase.firestore

// if using Firebase JS SDK < 5.8.0
db.settings({ timestampsInSnapshots: true })